<template>
  <div class="d-flex flex-column flex-root">
    <!-- <div class="d-flex flex-column flex-root" v-if="isAuthenticated"> -->

    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Content -->

        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
          <div class="d-flex justify-space-between align-center">
            <!-- begin:: Content Head -->
            <KTSubheader
              v-if="subheaderDisplay"
              v-bind:breadcrumbs="breadcrumbs"
              v-bind:title="pageTitle"
            />
            
            <div class="d-flex flex-row align-center">
              <p class="d-flex align-items-center m-3 welcome-text">{{$t('welcome.hello')}} {{this.currentUser.firstname}},</p>
              <v-badge v-if="isFreemium" v-show="!freemiumAlert"
              transition="fade-transition"
              :content="videosLeft"
              :value="isFreemium"
              color="#e6057d"
              overlap
              left
              bordered
            >
              <a
                @click="toggleFreemiumAlert"
                class="btn btn-primary align-self-end"
                ><v-icon class="ma-0 pa-0" x-small color="white">fas fa-video</v-icon></a
              >
            </v-badge>
            <a class="mx-4" @click="onClickNotification">
              <v-badge color="error" :content="allNotification.length || '0'">
                <v-icon>mdi-bell-outline</v-icon>
              </v-badge>
            </a>

            <v-card
              v-if="viewNotif"
              outlined
              class="notification-list"
              elevation="2"
            >
              <div v-if="allNotification.length == 0" class="notification-empty">
                Aucune notification
              </div>

              <div
                v-for="notification in allNotification"
                :key="notification.id"
                class="notification-item d-flex justify-space-between align-center"
                :class="{
                  'notification-info': notification.type == 'INFO',
                  'notification-warning': notification.type == 'WARNING',
                  'notification-error': notification.type == 'ERROR'
                }"
              >
                <div class="d-flex align-center">
                  <v-icon
                    :color="getTypeColor(notification.type)"
                    class="mr-2"
                  >
                    {{ getTypeIcon(notification.type) }}
                  </v-icon>
                  <div>
                    <p class="align-self-end m-3" style="font-weight: bold;">{{ notification.title }}</p>
                    <p class="align-self-end m-3">{{ notification.description }}</p>
                  </div>
                </div>
                <v-btn
                  v-if="!notification.isProgress"
                  small
                  icon
                  class="ml-2"
                  @click="deleteNotif(notification.id)"
                >
                  <v-icon color="red">mdi-close</v-icon>
                </v-btn>
                <v-icon v-if="notification.isProgress" class="ml-2 loading-icon">mdi-loading</v-icon>
              </div>
            </v-card>
              <a
                @click="onClickDisconnectButton"
                class="btn btn-primary align-self-end m-3"
                >{{$t("quickUser.logout")}}</a
              >
            </div>
          </div>
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid,
              }"
            >
              <div >
                <v-alert v-if="isFreemium" v-show="freemiumAlert"
                  color="#e6057d"
                  dense
                  border="left"
                  elevation="2"
                  colored-border
                  transition="fade-transition"
                >
                <v-row align="center">
                  <v-col class="shrink">
                    <v-icon color="#e6057d">fas fa-video</v-icon>
                  </v-col>
                  <v-col v-html="$i18n.t('freemium.banner.message',{videosLeft: videosLeft, videosAuthorized : videosAuthorized, videosPeriod : videosPeriod})" class="grow"/>
                  <v-col class=" ma-0 shrink">
                    <v-btn @click="toggleFreemiumAlert" dark color="#e6057d" medium>{{$t('freemium.banner.button')}}</v-btn>
                  </v-col>
                </v-row>
                </v-alert>
              </div>
              <transition name="fade-in-up">
                <router-view :key="$route.fullPath"></router-view>
              </transition>
            </div>
          </div>
        </div>

        <KTFooter></KTFooter>
      </div>
    </div>
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<style scoped>
  @media only screen and (max-width: 721px) {
    .welcome-text{ display: none !important; }
  }

@media (max-width: 991px) {
  .notification-list{
    top: 106px !important;
    width: 35% !important;
    max-height: 30% !important;
  }
}

.notification-list {
  position: absolute;
  top: 55px;
  right: 8px !important;
  width: 350px;
  min-width: 200px;
  max-height: 20%;
  overflow-y: auto;
  z-index: 10;
}

.notification-item {
  padding: 10px;
  border-radius: 3px;
  border-bottom: 1px solid rgb(172, 169, 169);
  margin-bottom: 1px;
}

.notification-item:hover {
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  background-color: pink;
}

.notification-info {
  border-left: 4px solid #39b42e;
}

.notification-warning {
  border-left: 4px solid #ffc107;
}

.notification-error {
  border-left: 4px solid #f44336;
}

.notification-empty {
  text-align: center;
  color: gray;
  font-size: 14px;
  padding: 10px;
}

.loading-icon {
  animation: spin 2s linear infinite;
}

.notification-empty {
  text-align: center;
  color: gray;
  font-size: 14px;
  padding: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import Api from "@/core/services/api.service";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import {getUserVideosAuthorized, getUserVideosPeriod, getUserVideosLeft} from "@/core/utils/user";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTScrollTop,
    Loader,
  },
  data: () => ({
    freemiumAlert: true,
    viewNotif: false,
    allNotification : [],
    testdesc : "test test"
  }),
  beforeMount() {
    if(localStorage.getItem('FREEMIUM_ALERT_STATUS') === null){
      localStorage.setItem('FREEMIUM_ALERT_STATUS', 'show');
    }
    localStorage.getItem('FREEMIUM_ALERT_STATUS') == 'show' ? this.freemiumAlert = true : this.freemiumAlert = false;
    
    // Vérification si l'utilisateur est authentifié
    if (!this.$store.getters.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
    // Affichage du loader
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // Initialisation HTML
    HtmlClass.init(this.layoutConfig());
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  mounted() {
    // Simulation d'un chargement de page
    setTimeout(() => { this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");}, 2000);
    document.addEventListener("click", this.handleOutsideClick);
    this.getNotification();
  },
  methods: {
     handleOutsideClick(event) {
      const notifPanel = this.$el.querySelector(".notification-list");
      const notifButton = this.$el.querySelector(".mdi-bell-outline");
      
      if (notifPanel && notifButton && !notifPanel.contains(event.target) && !notifButton.contains(event.target)) {
        this.viewNotif = false;
      }
    },
    toggleFreemiumAlert(){
      this.freemiumAlert = !this.freemiumAlert;
      this.freemiumAlert ? localStorage.setItem('FREEMIUM_ALERT_STATUS', 'show') : localStorage.setItem('FREEMIUM_ALERT_STATUS', 'hide');
    },
    /**
     * Méthode de déconnexion
     */
    onClickDisconnectButton() {
      this.$router.push({ name: "logout" });
    },

    onClickNotification() {
      this.viewNotif = !this.viewNotif;
    },

    getNotification(){
      Api.post("notification-data").then((response) => {
        this.allNotification = response.data.data;
        for(var i = 0; i < this.allNotification.length; i++){
          this.allNotification[i].isProgress = false;
        }
      })
    },
    
    deleteNotif(idNotif){
      Api.delete("notifications/" + idNotif).then(() => {
        this.getNotification();
      });
    },

    getTypeIcon(type) {
      switch (type) {
        case "INFO":
          return "mdi-information-outline";
        case "WARNING":
          return "mdi-alert-outline";
        case "ERROR":
          return "mdi-alert-circle-outline";
        default:
          return "mdi-bell-outline";
      }
    },

    getTypeColor(type) {
      switch (type) {
        case "INFO":
          return "blue";
        case "WARNING":
          return "orange";
        case "ERROR":
          return "red";
        default:
          return "gray";
      }
    },
  },
  computed: {
    ...mapGetters([
      "isFreemium",
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser"
    ]),

    /**
     * Récupération des vidéos restantes à voir
     */
    videosLeft(){
      return String(getUserVideosLeft(this.currentUser));
    }, 

    /**
     * Récupération des vidéos restantes à voir
     */
    videosAuthorized(){
      return String(getUserVideosAuthorized(this.currentUser));
    }, 
    /**
     * Récupération des vidéos restantes à voir
     */
    videosPeriod(){
      return String(getUserVideosPeriod(this.currentUser));
    }, 

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },

    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
  },
};
</script>

